
  import React from "react"
  import Component from "W:/www/baumstarksoft/www/src/layouts/index.js"
  import data from "W:\\www\\baumstarksoft\\www\\.cache\\json\\layout-index.json"

  export default (props) => <Component {...props} {...data} />
  


// WEBPACK FOOTER //
// ./.cache/layouts/index.js